function load (key, store) {
  if (localStorage.getItem(key)) {
    let loaded = JSON.parse(localStorage.getItem(key))
    if (loaded) {
      for (let i in loaded) {
        store[i] = loaded[i]
      }
    }
  }
}

function save (key, store) {
  delete store.auth.user
  localStorage.setItem(key, JSON.stringify(store))
}

export default (data, key) => {
  load(key, data)
  window.onunload = () => save(key, data)
}



// WEBPACK FOOTER //
// ./src/store/debug.js